import React, {useState} from 'react';
import {
    FunctionField,
    RichTextField,
    Show,
    Tab,
    TabbedShowLayout,
    TextField,
    TextInput,
    useRedirect
} from 'react-admin';
import {makeStyles} from "@material-ui/core/styles";
import GradientButton from "../../../Component/Layouts/Button/GradientButton";
import {convertedDateWithTime} from "../../../Functions/ConvertedDate";
import {Typography} from "@mui/material";
import {useRecordContext} from "react-admin";

export const AiSettingsShow = () => {
    const redirect = useRedirect();
    const rd = useRecordContext();

    const navigateToEdit = () => {
        redirect(`/ai/settings/custom/edit`)
    }
    const SystemPrompt = ({ record }) => (
        <Typography style={{ whiteSpace: 'pre-wrap' }}>
            {record.systemPrompt}
        </Typography>
    );

    const PromptTemplate = ({ record }) => (
        <Typography style={{ whiteSpace: 'pre-wrap' }}>
            {record.promptTemplate}
        </Typography>
    );

    const InfoShowTab = () => {
        const record = useRecordContext();
        if (!record) return null;

        return (
            <TabbedShowLayout>
            <Tab label="Details">
                <div>
                    <GradientButton  style={{float: 'right'}} label={'Edit'} onClick={() => navigateToEdit()}  />
                </div>
                <TextField label='OpenAI Model:' source="model"/>
                {record.model === 'gpt-4.1' && <TextField label='Temperature (0.0 - 2.0):' source="temperature"/>}
                {record.model === 'gpt-5.2' && <TextField label='Effort:' source="effort"/>}
                {record.model === 'gpt-5.2' && <TextField label='Verbosity:' source="verbosity"/>}
                {record.model === 'gpt-5.2' && <TextField label='Top P (0.0 - 1.0):' source="top_p"/>}
                <TextField label='Tokens:' source="token"/>
                <FunctionField label="Store" render={(record) => {
                    return record.store ? 'yes' : 'no';
                }}/>
                <FunctionField label="System Prompt:" render={(record) => {
                    return <SystemPrompt record={record} />;
                }}/>
                <FunctionField label="User Prompt Template:" render={(record) => {
                    return <PromptTemplate record={record} />;
                }}/>
            </Tab>
            </TabbedShowLayout>
        );
    };

    return (
        <>
            <Show actions={<></>}>
                <InfoShowTab />
            </Show>
        </>
    );
};
